<template>
  <div class="quicksearch__dropdown">
    <a-spinner
      v-if="inProgress"
      :size="30"
      :stroke="5"
      disable-transition
      class="quicksearch__spinner"
    />
    <div v-else-if="items.length" class="quicksearch__results">
      <ul class="quicksearch__list">
        <li
          v-for="item in items"
          :key="item.Slug"
          class="quicksearch__list-item text-caption"
        >
          <a-link :to="settings.generateItemUrl(item)" @click="onBlur">{{
            item.Name
          }}</a-link>
        </li>
      </ul>
      <a-button
        v-if="!hideResultButton"
        class="quicksearch__btn"
        @click="settings.viewAllResultsClickHandler"
      >
        View all results
      </a-button>
    </div>
    <div v-else class="quicksearch__no-results text-caption">
      No results found
    </div>
  </div>
</template>

<script>
import ASpinner from 'shared/ASpinner'
import { PROP_TYPES, propValidator } from '@/utils/validators'

export default {
  name: 'QuickSearchResults',
  components: { ASpinner },
  props: {
    items: propValidator([PROP_TYPES.ARRAY]),
    settings: propValidator([PROP_TYPES.OBJECT]),
    inProgress: propValidator([PROP_TYPES.BOOLEAN]),
    hideResultButton: propValidator([PROP_TYPES.BOOLEAN])
  },
  methods: {
    onBlur() {
      this.$emit('blur')
    }
  }
}
</script>

<style lang="scss" scoped>
.quicksearch__dropdown {
  position: absolute;
  top: 38px;
  left: 0;
  width: 100%;
  min-height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid $c--main;
  box-shadow: 0 10px 10px 0 rgba($c--black, 0.3);
  background: $c--white;
  z-index: 1;

  .quicksearch__results {
    width: 100%;
  }

  .quicksearch__list {
    padding: 12px 30px 20px 20px;
  }

  .quicksearch__list-item {
    line-height: 34px;
    border-bottom: solid 2px $c--row-delimiter;

    & > * {
      display: inline-block;
      width: 100%;
    }

    &:last-child {
      border: none;
    }
  }

  .quicksearch__btn {
    width: 100%;
  }

  .quicksearch__no-results {
    text-align: center;
    color: $c--main;
  }
}
</style>
